import { Typography } from "@mui/material";

export default function SubTitlePages({children, ...props}){
    return (
        <Typography {...props}>
            {children}
        </Typography>
    )
}